import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox, {ComboBoxProps, GroupByDef} from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";

/**
 * Componente per la selezione di un turno.
 * N.B. Il valore restituito a livello di form rappresenta unicamente il codice del turno, per prelevare invece l'intero oggetto valorizzare il metodo onChange
 * @param props
 * @constructor
 */
interface ComboBoxTurnoProps<T extends FieldValues> extends Pick<ComboBoxProps<T>, 'addOnBefore' | 'addOnAfter' | 'label' | 'inlineLabel' | 'disabled' | 'labelClassName'> {
    control: Control<T>,
    name: FieldPath<T>,
    defaultValue: any,
    label: string,
    data: TurnoRecord[] | undefined,
    isLoading?: boolean,
    onChange?: (v: TurnoRecord | null) => void,
    rules?: Omit<RegisterOptions<T, FieldPath<T>>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>,
    valueAsObject?: boolean,
    raggruppaOpts?: boolean,
}

const gruppiTurni: GroupByDef<TurnoRecord>[] = [
    {descrizione: 'Orario base', filter: (item) => item.tipologia === '_BASE', key: '_BASE'},
    {descrizione: 'Alternativi', filter: (item) => item.tipologia === 'ALT_AUTO', key: 'ALT_AUTO'},
    {descrizione: 'Alternativi manuali', filter: (item) => item.tipologia === 'ALT_MANUALE', key: 'ALT_MANUALE'},
    {descrizione: 'Gestione a consuntivo', filter: (item) => item.tipologia === '_CONSUNTIVO', key: '_CONSUNTIVO'},
]

export function ComboBoxTurno<T extends FieldValues>(props: ComboBoxTurnoProps<T>) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={props.rules}
                       render={({field: {value, onChange}, fieldState}) => {
                           const val = props.valueAsObject ? value : {codTurno: value};

                           return <ComboBox<TurnoRecord> label={props.label} labelClassName={props.labelClassName} value={val} onChange={(value) => {
                               if (props.valueAsObject)
                                   onChange(value);
                               else
                                   onChange(value?.codTurno);
                               if (props.onChange)
                                   props.onChange(value);
                           }}
                                                         data={props.data} isLoading={props.isLoading}
                                                         searchablePropsName={["codTurno", "descrizione"]}
                                                         fieldState={fieldState}
                                                         isSameFn={(a, z) => (a && z) ? a.codTurno === z.codTurno : false}
                                                         keyValueFn={(v) => v.codTurno!}
                                                         displayValueFn={(v) => props.data && v ? `${v.descrizione} [#${v.codTurno}]` : ''}
                                                         addOnBefore={props.addOnBefore}
                                                         addOnAfter={props.addOnAfter}
                                                         disabled={props.disabled}
                                                         inlineLabel={props.inlineLabel}
                                                         groupByDefs={props.raggruppaOpts ? gruppiTurni : undefined}
                           />;
                       }}
    />
}